import React from 'react';
import { makeStyles } from '@material-ui/core';
import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@material-ui/core/Tooltip';

const useStyles = makeStyles(() => ({
  arrow: {
    color: '#333',
  },
  tooltip: {
    fontSize: 14,
    backgroundColor: '#333',
    padding: '8px 12px',
  },
}));

type TooltipProps = Omit<MuiTooltipProps, 'title'> & { title: React.ReactNode };

const Tooltip: React.FC<TooltipProps> = React.memo<TooltipProps>(function Tooltip(props) {
  const classes = useStyles();

  if (!props.title) return props.children;
  // @ts-ignore
  return <MuiTooltip classes={classes} {...props} />;
});

export default Tooltip;
